// extracted by mini-css-extract-plugin
export default {"wrap":"style_wrap__n34Pj","title":"style_title__QKNNq","description":"style_description__1UtJx","buttons":"style_buttons__tQYOY"};